import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function PageSkeleton() {
  return (
    <div className="skeleton-wrapper">
      <Skeleton height={300} />
      <div className="skeleton-content">
        <Skeleton count={3} />
        <Skeleton width={200} height={50} />
      </div>
      <div className="skeleton-cards">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="skeleton-card">
            <Skeleton height={150} />
            <Skeleton count={2} />
          </div>
        ))}
      </div>
    </div>
  );
}
